import { useSelector, useDispatch } from 'react-redux';
import switchPageSlice from './switchPageSlice';

function useSwitchPage() {
    const { page } = useSelector((state) => {
        return state.switchPage;
    });
    const dispatch = useDispatch();
  
    function setPage(page) {
      dispatch(switchPageSlice.actions.setPage(page));
    }
  
    return { page, setPage };
}

export default useSwitchPage;